module.exports = __webpack_public_path__ + "img/500.2f259709.png";